module.exports = __webpack_public_path__ + "media/images/cardboard-bg-04-309f1344c362284464811532db589ad1.png";